import { Leaf, Sparkles, Sprout, Lock, Waves, Plane, Utensils, Home, MapPin } from "lucide-react";

export const PRIORITY_META = {
  ayurveda: { label: "Ayurvedic Healing", icon: Leaf, desc: "Physician-led therapies & sattvic cuisine" },
  mind_detox: { label: "Mind Detox", icon: Sparkles, desc: "Meditation, breathwork & digital stillness" },
  agri: { label: "Agri Immersion", icon: Sprout, desc: "Spice gardens, tea estates & chef's table" },
  privacy: { label: "Absolute Privacy", icon: Lock, desc: "Seclusion, butler service & private dining" },
};

export const CATEGORY_ICON = {
  ayurveda: Leaf,
  mind_detox: Sparkles,
  agri: Sprout,
  privacy: Lock,
  coastal: Waves,
  transfer: Plane,
  dining: Utensils,
  arrival: Home,
  default: MapPin,
};
